import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetDictionaryList, PaginatedDTO } from 'src/app/Common/common.interface';
import { ComapnyMaster_SearchByName, CompanyMaster_create, CompanyMaster_delete, CompanyMaster_GetDictionary, CompanyMaster_readAll, CompanyMaster_readAllPaginated, CompanyMaster_ReadByGSTNo, CompanyMaster_readById, CompanyMaster_readByUserId, CompanyMaster_SearchByNameLogin, CompanyMaster_update } from 'src/app/GlobalVariables';
import { CompanyMasterCreateRequestDTO, CompanyMasterDeleteRequestDTO, CompanyMasterDTO, CompanyMasterList, CompanyMasterReadByGSTNoRequestDTO, CompanyMasterReadByIdRequestDTO, CompanyMasterReadByUserIdRequestDTO, CompanyMasterSearchByNameRequestDTO, CompanyMasterUpdateRequestDTO } from './companies.interface';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  http = inject(HttpClient)

  constructor() { }

  CompanyMaster_create(data: CompanyMasterCreateRequestDTO): Observable<CompanyMasterDTO> {
    return this.http.post<CompanyMasterDTO>(CompanyMaster_create, data)
  }

  CompanyMaster_update(data: CompanyMasterUpdateRequestDTO): Observable<CompanyMasterDTO> {
    return this.http.post<CompanyMasterDTO>(CompanyMaster_update, data)
  }

  CompanyMaster_readAll(): Observable<CompanyMasterList> {
    return this.http.get<CompanyMasterList>(CompanyMaster_readAll)
  }

  CompanyMaster_delete(data: CompanyMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CompanyMaster_delete, data)
  }

  CompanyMaster_readAllPaginated(data: PaginatedDTO): Observable<CompanyMasterList> {
    return this.http.post<CompanyMasterList>(CompanyMaster_readAllPaginated, data)
  }

  // baseUrlOverride (optional, read methods only): the viewed tenant's own
  // AM gateway origin, e.g. CompanyDetailComponent.apiConfigOverride.AM.
  // Omitted for every other caller - behaves exactly as before.
  CompanyMaster_readById(data: CompanyMasterReadByIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<CompanyMasterDTO> {
    return this.http.post<CompanyMasterDTO>(resolveTenantUrl(CompanyMaster_readById, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
  }

  ComapnyMaster_SearchByName(data: CompanyMasterSearchByNameRequestDTO): Observable<CompanyMasterList> {
    return this.http.post<CompanyMasterList>(ComapnyMaster_SearchByName, data)
  }

  CompanyMaster_SearchByNameLogin(data: CompanyMasterSearchByNameRequestDTO): Observable<CompanyMasterList> {
    return this.http.post<CompanyMasterList>(CompanyMaster_SearchByNameLogin, data)
  }

  CompanyMaster_readByUserId(data: CompanyMasterReadByUserIdRequestDTO): Observable<CompanyMasterList> {
    return this.http.post<CompanyMasterList>(CompanyMaster_readByUserId, data)
  }

  CompanyMaster_GetDictionary(data: CompanyMasterReadByUserIdRequestDTO): Observable<GetDictionaryList> {
    return this.http.post<GetDictionaryList>(CompanyMaster_GetDictionary, data);
  }

  CompanyMaster_ReadByGSTNo(data: CompanyMasterReadByGSTNoRequestDTO): Observable<CompanyMasterList> {
    return this.http.post<CompanyMasterList>(CompanyMaster_ReadByGSTNo, data)
  }

  // Explicitly opts a tenant-overridden request out of ApiUrlRewriteInterceptor's
  // app-wide rewriting (keyed to the LOGGED-IN user's own tenant) - resolveTenantUrl()
  // has already pointed this request at the correct viewed-tenant origin.

}
